import { useTranslation } from 'react-i18next';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LiliButton } from '@lili/lili-frontend-common';
import { GENERAL_STYLE, FORGOT_EMAIL_SUCCESS_PAGE_DATA } from '../constants';
import LoginCard from '../../../components/LoginCard';
import Heading from '../../../../../generic-components/Heading';
import Lottie from '../../../../../generic-components/Lottie';
import CheckSignLottie from '../../../../../assets/lotties/checkmark_success_animation.json';
import { LoginHelpNavBar } from '../LoginHelpNavBar';
import { VIEWS_MAP } from '../../../../../router/constants';
import { Layout } from '../../../../../components/Layout/Layout';

const ForgotEmailSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const supportEmail = 'support@lili.co';

  return (
    <Layout shouldHideProfile shouldHideChatBot wrapperClassName='pt-[78px] pl-[72px] ml-[100px] pc-md:ml-[256px]'>
      <LoginHelpNavBar
        onBackClick={() => {}}
        onCloseClick={() => {
          navigate(`/${VIEWS_MAP.LOGIN}`);
        }}
        hideBackIcon
      />
      <LoginCard className={GENERAL_STYLE.LOGIN_CARD.CLASS_NAME} hideLiliIcon>
        <div className='flex flex-col justify-between h-full'>
          <div className='flex flex-col items-center '>
            <Lottie
              className='w-[96px] h-[96px] mb-[36px]'
              isAutoplay
              isLoop={false}
              lottieAsset={CheckSignLottie}
            />
            <Heading
              title={t(FORGOT_EMAIL_SUCCESS_PAGE_DATA.HEADING_TEXT)}
              className={`${GENERAL_STYLE.HEADING.CLASS_NAME} mb-[4px] text-center`}
            />
            <p className={`${GENERAL_STYLE.DESCRIPTION.CLASS_NAME} mb-[90px] text-center`}>
              {t(FORGOT_EMAIL_SUCCESS_PAGE_DATA.SUBTITLE_TEXT)}
              {' '}
              <p className={`${GENERAL_STYLE.DESCRIPTION.CLASS_NAME} text-action03`}>
                {supportEmail}
              </p>
            </p>
          </div>
          <LiliButton
            id='continueToLoginBtn'
            title={t(FORGOT_EMAIL_SUCCESS_PAGE_DATA.CONTINUE_BUTTON_TEXT)}
            className={GENERAL_STYLE.MAIN_BUTTON.CLASS_NAME}
            onClick={() => {
              navigate(`/${VIEWS_MAP.LOGIN}`);
            }}
          />
        </div>

      </LoginCard>
    </Layout>
  );
};

export default ForgotEmailSuccess;
